import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useDispatch, useSelector } from "react-redux";
import { updateBlog } from "store/blogSlice";
import { useParams, useHistory } from "react-router-dom";
import { quillModules } from "./quillConfig";

export default function BlogEdit({color}) {
  const { id } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();

  const blog = useSelector((state) =>
    state.blogs.items.find((b) => b.id === Number(id))
  );

  const [imagePreview, setImagePreview] = useState(null);


  const [slug, setSlug] = useState("");
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [image, setImage] = useState(null);
  const [isPublished, setIsPublished] = useState(true);

  useEffect(() => {
    if (blog) {
      setTitle(blog.title);
      setSlug(blog.slug);
      setDescription(blog.description);
      setIsPublished(blog.is_published);
    }
  }, [blog]);

  const handleSubmit = (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("title", title);
    formData.append("slug", slug);
    formData.append("description", description);
    formData.append("is_published", isPublished);
    if (image) formData.append("image", image);

    dispatch(updateBlog({ id, data: formData })).then(() => {
      history.push("/admin/blog");
    });
  };

  if (!blog) return <p className="p-6">Loading...</p>;

  return (
    <div
      className={
        "relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded " +
        (color === "light" ? "bg-white" : "bg-lightBlue-900 text-white")
      }
    >
      <div className="max-w-5xl mx-auto p-6 bg-white shadow rounded">
        <h2 className="text-xl font-semibold mb-4">Edit Blog</h2>

        <form onSubmit={handleSubmit} className="space-y-4">
          {/* Title */}
          <div>
            <label className="block text-sm font-medium mb-1">Title</label>
            <input
              type="text"
              className="w-full border px-3 py-2 rounded"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
          </div>
          <div>
    <label className="block text-sm font-medium mb-1">Slug</label>
    <input
      type="text"
      className="w-full border px-3 py-2 rounded"
      value={slug}
      onChange={(e) => setSlug(e.target.value)}
      required
    />
  </div>


          {/* Image */}
          <div>
            <label className="block text-sm font-medium mb-1">Image</label>
            {blog.image && !imagePreview && (
              <img
                src={blog.image}
                alt={blog.title}
                className="h-32 w-auto rounded border mb-2"
              />
            )}

            {imagePreview && (
              <img
                src={imagePreview}
                alt="Preview"
                className="h-32 w-auto rounded border mb-2"
              />
            )}

            <input
              type="file"
              onChange={(e) => {
                const file = e.target.files[0];
                setImage(file);
                if (file) setImagePreview(URL.createObjectURL(file));
              }}
            />
            {/* <input
              type="file"
              onChange={(e) => setImage(e.target.files[0])}
            /> */}
          </div>

          {/* Description */}
          <div>
            <label className="block text-sm font-medium mb-1">
              Description
            </label>
            <ReactQuill
              theme="snow"
              value={description}
              onChange={setDescription}
              modules={quillModules}
            />
          </div>

          {/* Published */}
          <div className="flex items-center space-x-2">
            <input
              type="checkbox"
              checked={isPublished}
              onChange={(e) => setIsPublished(e.target.checked)}
            />
            <label>Is Published</label>
          </div>

          {/* Buttons */}
          <div className="flex space-x-2">
            <button
              type="submit"
              className="bg-lightBlue-600 text-white px-4 py-2 rounded"
            >
              Update
            </button>
            <button
              type="button"
              onClick={() => history.push("/admin/blog")}
              className="bg-gray-300 px-4 py-2 rounded"
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

BlogEdit.defaultProps = {
  color: "light",
};

BlogEdit.propTypes = {
  color: PropTypes.oneOf(["light", "dark"]),
};
